import React, { FunctionComponent, ReactNode } from 'react';
import { isInitialExperimentPostPaymentQuestions } from '../../utils/statsig';

interface PostMandatoryQuestionsExperimentWrapperProps {
    getComponent: (isPostPaymentQuestionsExperiment: boolean) => ReactNode;
}

const PostMandatoryQuestionsExperimentWrapper: FunctionComponent<
    PostMandatoryQuestionsExperimentWrapperProps
> = ({ getComponent }) => (
    <>{getComponent(isInitialExperimentPostPaymentQuestions())}</>
);

export default PostMandatoryQuestionsExperimentWrapper;
